module.exports = __webpack_public_path__ + "img/ar.f46df3f2.svg";